import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import {
  addModel,
  addProject,
  clearDashboard,
  clearPane,
  editModelFlow,
  removeModelFlow,
  searchModel,
  updateCurrent,
  renameFlow,
  setDefault,
} from './actions';
import api from '../../services/api';

//rota -> modelflows/
export const fetchFlows = createAsyncThunk(
  'flows/fetchFlows',
  async ({ tenantId, page, queries = {} }, { rejectWithValue }) => {
    const { title, filters } = queries;
    const { alpha = false, creation = false } = filters;

    try {
      let query =
        '?title=' + title + '&alpha=' + alpha + '&creation=' + creation;

      const response = await api.get(
        '/modelflows/pagination/' + tenantId + '/' + page + '/' + query
      );

      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

//rota -> flowpane/
export const fetchSingleFlow = createAsyncThunk(
  'flows/fetchSingle',
  async ({ _id }, { rejectWithValue }) => {
    try {
      const response = await api.get('/modelflows/flow/' + _id);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const flowsReducer = createReducer(
  {
    dashboard: {
      status: 'idle',

      flows: [],
    },
    pane: {
      status: 'idle',
      flow: {
        main: {},
        versions: [],
        current: {},
      },
    },
  },
  {
    [fetchFlows.pending]: (state) => {
      state.dashboard.status = 'loading';
    },
    [fetchFlows.fulfilled]: (state, action) => {
      const apiFlows = action.payload;
      state.dashboard.status = 'succeeded';
      state.dashboard.flows = apiFlows.flows;
      state.dashboard.pages = apiFlows.pages;
    },

    [fetchSingleFlow.pending]: (state) => {
      state.pane.status = 'loading';
    },
    [fetchSingleFlow.fulfilled]: (state, action) => {
      const apiFlow = action.payload;

      state.pane.flow.main = apiFlow.flow.main;
      state.pane.flow.versions = apiFlow.flow.versions;
      state.pane.status = 'succeeded';
    },

    /**
     * ? addModelFlow
     * * Criação de um fluxo
     */
    [addProject]: (state, action) => {
      const flow = action.payload.flow;
      state.pane.flow.main = flow;
    },

    [addModel]: (state, action) => {
      const flow = action.payload.flow;
      //versions
      const versions = state.pane.flow.versions;
      state.pane.flow.versions = [...versions, flow];
    },
    [updateCurrent]: (state, action) => {
      const currentFlow = action.payload.flow;
      if (!currentFlow) {
        return;
      }
      state.pane.flow.current = currentFlow;
    },

    /**
     * ? editModelFlow
     * * Edição de um fluxo
     */
    [editModelFlow]: (state, action) => {
      const flow = action.payload.flow;
      if (!flow) {
        return;
      }
      const versions = state.pane.flow.versions;

      if (flow.type === 'main') {
        state.pane.flow.main = flow;
      } else {
        state.pane.flow.versions = versions.map((version) =>
          version._id === flow._id ? (version = flow) : version
        );
      }
      state.pane.flow.current = flow;
    },
    /**
     * ? RemoveModelFlow
     * * Filtra o estado atual pelo _-id com relação ao
     * * fluxo a ser removido.
     */

    [removeModelFlow]: (state, action) => {
      const flow = action.payload.flow;
      const flowId = flow.flowId;
      const baseModel = flow.baseModel;

      const versions = state.pane.flow.versions;

      if (baseModel) {
        const baseFlowId = baseModel.flowId;
        const mainFlow = state.pane.flow.versions.find(item => item._id === baseFlowId)
        const base = {
          ...mainFlow,
          type: 'main',
          parentId: null,
          default: baseModel.default
        }
        state.pane.flow.main = base;
        state.pane.flow.current = base;
        state.pane.flow.versions = versions.filter(
          (version) => version._id !== baseFlowId
        );


      } else {
        state.pane.flow.versions = versions.filter(
          (version) => version._id !== flowId
        );
      }
    },

    [renameFlow]: (state, action) => {
      const flow = action.payload.flow;
      const { lastUpdate, title } = flow;

      if (flow.type === 'version') {
        state.pane.flow.versions = state.pane.flow.versions.map((version) =>
          version._id === flow._id ? { ...version, lastUpdate, title } : version
        );
      } else {
        state.pane.flow.main = {
          ...state.pane.flow.main,
          lastUpdate,
          title,
        };
      }
      state.pane.flow.current = {
        ...state.pane.flow.current,
        lastUpdate,
        title,
      };
    },

    [setDefault]: (state, action) => {
      state.pane.flow.main.default = action.payload.flow.default;
    },

    /**
     * ? clearDashboard
     * * Limpa o estado atual localmente de fluxos modelos cadastrados
     */
    [clearDashboard]: (state) => {
      state.dashboard.status = 'idle';
      // state.dashboard.pages = 1;
      state.dashboard.flows = [];
    },
    [clearPane]: (state) => {
      state.pane.status = 'idle';
      state.pane.flow.main = {};
      state.pane.flow.versions = [];
      state.pane.flow.current = { id: null, title: null };
    },
    [searchModel]: (state, action) => {
      // state.entities = action.payload.flows;
      // state.pages = action.payload.pages;
    },
  }
);

export default flowsReducer;
